<!--
  "オンライン健康相談を表すタブ情報"を実装実体に受け渡すためのwrapped実装
-->
<template>
  <CounselingImpl
    tab="online"
    type="reserve"
    counseling_type="1"
  />
</template>

<script>
import CounselingImpl from '@/views/pages/Counselor/tabs/impl/CounselingImpl.vue';

export default {
  name: 'counselor-online-counseling',
  components: {
    CounselingImpl,
  },
  data() {
  },
  methods: {
  },
};
</script>
